// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"869d5d98","388":"0c2ecbf9","426":"b002abd3","453":"19a30ac3","798":"4aa5a8a4","878":"d1ebace6","981":"80a7031a","982":"7c322602"}[chunkId] + ".chunk.js";
};